import React, { Component } from 'react';
import { Player, Controls } from "@lottiefiles/react-lottie-player";
import { API_ENDPOINT } from '../../../constants';
import PayModal from './payModal';


class StripeCheckTransactionPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true
        };
    }

    checkTransaction = async (transactionId) => {
        try {
            let response = await fetch(`${API_ENDPOINT}/api/payments/check/transaction/${transactionId}`, {
                method: 'GET',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                }
            })
            let result = await response.json();
            return result;
        } catch (error) {
            console.error('Error checking transaction:', error);
            return null;
        }
    }

    componentWillUnmount() {
        window.removeEventListener("popstate", this.onBackButtonEvent);
        if (this.state.payModal) {
            this.setState({ payModal: null });
        }
        if (this.interval) {
            clearInterval(this.interval);
        }

    }

    backButtonBlock = () => {
        window.history.pushState(null, "", window.location.href);
        this.onBackButtonEvent = () => {
            window.history.go(1);
        };

        window.addEventListener("popstate", this.onBackButtonEvent);
    }
    get = async () => {
        const redirectUrl = this.props[0].location.state?.redirectUrl;
        this.backButtonBlock();

        const transaction = this.props[0].match.params.transaction;

        if (redirectUrl) {
            this.props[0].history.push({ state: {} });
            window.location.href = redirectUrl;
            return;
        }

        let transactionId, transactionStatus = '';
        if (transaction?.indexOf('stripe-success') > -1) {
            transactionId = transaction.replace('stripe-success', '');
            transactionStatus = 'stripe-success';
        } else if (transaction?.indexOf('stripe-cancel') > -1) {
            transactionId = transaction.replace('stripe-cancel', '');
            transactionStatus = 'stripe-cancel';
        }
        if (transactionStatus === 'stripe-cancel') {
            let check = await this.checkTransaction(transactionId);
            if (check?.caseData?._id) {
                const caseData = check.caseData;
                const caseId = caseData._id;
                const { wayOfScheduling, status, paymentBeforeSubmission, paymentAfterSubmission } = caseData;
                let isDeleteNeededOnAbortPayment = false;
                if (wayOfScheduling === 'bookingByClinic' && status === 'waiting-for-payment-before-submission' && paymentBeforeSubmission) {
                    isDeleteNeededOnAbortPayment = true;
                } else if (wayOfScheduling === 'webBooking' && paymentBeforeSubmission) {
                    isDeleteNeededOnAbortPayment = true;
                } else if (wayOfScheduling === 'dropIn' && (paymentBeforeSubmission || !paymentAfterSubmission)) {
                    isDeleteNeededOnAbortPayment = true;
                }
                if (isDeleteNeededOnAbortPayment) {
                    this.setState({ payModal: caseId });
                    return;
                }


            }
        }
        this.updateStripeTransaction(transaction);
    }
    componentDidMount() {
        this.get();

        this.interval = setInterval(() => {
            if (!this.updateStripeTransactionFunction && !this.state.payModal) {
                window.location.reload();
            }
        }, 1000 * 5);
    }
    updateStripeTransaction = (transaction) => {
        this.updateStripeTransactionFunction = true;
        this.setState({ loading: true }, () => {
            fetch(API_ENDPOINT + '/api/payments/stripe/update/transaction', {
                method: 'POST',
                headers: {
                    'content-type': 'application/json'
                },
                body: JSON.stringify({ transaction })
            }).then(res => res.json()).then((result) => {
                let setObj = { loading: false };
                if (result?.error) {
                    setObj.error = result.error;
                }
                this.setState(setObj, () => {
                    const successPayment = result?.successPayment === true ? true : false;
                    if (successPayment) {
                        if (result?.isCasePaymentBeforeSubmission && result?.caseId) {
                            if (this.props.trackFormSubission) this.props.trackFormSubission({ _id: result?.caseId });
                        }
                    }
                    const successMessage = "Payment has been made successfully.".translate(this.props.lang);
                    const failureMessage = "Payment failed, please make sure to pay before your scheduled visit.".translate(this.props.lang);
                    const message = successPayment ? successMessage : failureMessage;
                    this.redirectToLink('/my-data/patient/payments', { message: message });
                });
            });
        });
    }



    redirectToLink = (path = '/my-data/patient/payments', state = {}) => {
        this.props[0].history.push(path, state);
    }



    render() {
        return (
            <div className='fullscreen-loader' >
                {
                    this.state.loading && !this.state.payModal ?
                        <div className="loader-wrap" >
                            <Player
                                autoplay={true}
                                loop={true}
                                src="/lf30_editor_l5cxzdyf.json"
                                style={{ height: typeof window != 'undefined' && window.innerWidth < 768 ? "128px" : "256px", width: typeof window != 'undefined' && window.innerWidth < 768 ? "128px" : "256px" }}
                            ></Player>

                        </div>
                        :
                        null
                }

                {
                    this.props.lang && this.state.loading && !this.state.payModal ?
                        <p>{"Checking transaction...".translate(this.props.lang)}</p>
                        :
                        null
                }

                {
                    this.state.payModal ?
                        <PayModal
                            {...this.props}
                            isOpen={this.state.payModal}
                            caseId={this.state.payModal}
                            paymentOnCaseSubmit={true}
                            onClose={(callback) => {
                                if (callback) {
                                    callback();
                                }
                            }}
                        />
                        :
                        null
                }

            </div >




        );
    }
}

export default StripeCheckTransactionPage;